import { SIZE_LG, SIZE_MD } from '../../config/constants';

export const INPUT_TYPE_TEXT = 'text';
export const INPUT_TYPE_PASSWORD = 'password';
export const INPUT_TYPE_COLOR = 'color';
export const INPUT_TYPE_DATE = 'date';
export const INPUT_TYPE_DATETIME_LOCAL = 'datetime-local';
export const INPUT_TYPE_EMAIL = 'email';
export const INPUT_TYPE_MONTH = 'month';
export const INPUT_TYPE_NUMBER = 'number';
export const INPUT_TYPE_RANGE = 'range';
export const INPUT_TYPE_SEARCH = 'search';
export const INPUT_TYPE_TEL = 'tel';
export const INPUT_TYPE_TIME = 'time';
export const INPUT_TYPE_URL = 'url';
export const INPUT_TYPES = [
  INPUT_TYPE_TEXT,
  INPUT_TYPE_PASSWORD,
  INPUT_TYPE_COLOR,
  INPUT_TYPE_DATE,
  INPUT_TYPE_DATETIME_LOCAL,
  INPUT_TYPE_EMAIL,
  INPUT_TYPE_MONTH,
  INPUT_TYPE_NUMBER,
  INPUT_TYPE_RANGE,
  INPUT_TYPE_SEARCH,
  INPUT_TYPE_TEL,
  INPUT_TYPE_TIME,
  INPUT_TYPE_URL,
];

export const INPUT_BASE_CLASS = 'form-control';

export const FORM_CONTROL_SIZES = [
  SIZE_LG,
  SIZE_MD,
];

export const INPUT_GROUP_STYLE_DEFAULT = 'default';
export const INPUT_GROUP_STYLE_TRANSPARENT = 'transparent';

export const INPUT_GROUP_STYLES = [
  INPUT_GROUP_STYLE_DEFAULT,
  INPUT_GROUP_STYLE_TRANSPARENT,
];
